import React, { Component } from 'react'
import { connect } from 'react-redux';

import Header from '../../components/Header'
import BarraLateral from '../../components/BarraLateral';
import Relatorio from './relatorio'

import './relatorios.css'
import {

} from '../../actions'

class Relatorios extends Component {

    constructor(){
        super()
    }

    componentDidMount(){

    }

    render(){
        return(
            <div className="principal">
                <Header />
                
                <BarraLateral />

                <Relatorio />
            </div>
        )
    }
}


const mapStateToProps = ({ relatorio }) => {
    return {
        relatorio,
    }
}

export default connect(mapStateToProps, {

})(Relatorios);